// extracted by mini-css-extract-plugin
module.exports = {"addtodo":"addtodo_addtodo__2D8IJ","addtodo_text":"addtodo_addtodo_text__3fFc7"};